import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";
import queryString from "query-string";
import { isEmpty } from "lodash";

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 50;

const fetchQueue = async ({
  type = "praktek_offline",
  period,
  page = DEFAULT_PAGE,
  perPage = DEFAULT_PER_PAGE,
  ...params
}) => {
  const pathname = queryString.stringifyUrl({
    url: "/queues/search",
    query: {
      type,
      period,
      ...params,
    },
  });
  const { data } = await API.get(pathname);
  return data;
};

const useGetSearchQueue = ({ type, period, page, perPage, ...params }) => {
  return useQuery(
    [QUERY_KEY.GET_SEARCH_QUEUE, { period, page, ...params }],
    () =>
      fetchQueue({
        type,
        period,
        page,
        perPage,
        ...params,
      }),
    {
      retry: 3,
      keepPreviousData: false,
      cacheTime: 0,
      enabled: !isEmpty(period),
    }
  );
};

export default useGetSearchQueue;
